import React, { useState } from "react";
import axios from "../../axiosConfig";
// import axios from "axios";

import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext'; // 导入 AuthContext
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faMobile, 
  faKey, 
  faExclamationCircle, 
  faCheckCircle, 
  faPaperPlane
} from '@fortawesome/free-solid-svg-icons';
import Header from '../../components/Header';
import '../../styles/AuthPages.css';

const UserMobileRegister = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [message, setMessage] = useState("");
  // const [username, setUsername] = useState('');
  // const [password, setPassword] = useState('');

  const [verificationCode, setVerificationCode] = useState('');
  const [error, setError] = useState('');
  const [isVerifying, setIsVerifying] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [countdown, setCountdown] = useState(0);

  const { login } = useAuth(); // 从 AuthContext 获取 login 函数
  
    const navigate = useNavigate();

  const handleSendOtp = async () => {
    // 验证手机号格式
    // if (!/^1[3-9]\d{9}$/.test(phoneNumber)) {
    //   setError('请输入有效的手机号码');
    //   return;
    // }
    
    setIsSending(true);
    setError('');
    
    try {
      const response = await axios.post(
        "/otp/send",
        null,
        { params: { phoneNumber } }
      );
      
      if (response.data.code === 0) {
        setMessage("验证码已发送，请注意查收");
        setIsOtpSent(true);
        // 开始60秒倒计时
        setCountdown(60);
        const timer = setInterval(() => {
          setCountdown(prev => {
            if (prev <= 1) {
              clearInterval(timer);
              return 0;
            }
            return prev - 1;
          });
        }, 1000);
      } else {
        setError(response.data.msg || "发送验证码失败");
      }
    } catch (error) {
      setError("发送验证码失败：" + (error.response?.data?.msg || "网络错误"));
    } finally {
      setIsSending(false);
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    
    if (!otp || otp.length < 4) {
      setError('请输入完整的验证码');
      return;
    }
    
    setIsVerifying(true);
    setError('');
    
    try {
      const response = await axios.post(
        "/otp/verify",
        null,
        { params: { phoneNumber, otp } }
      );
      
      if (response.data.code === 0) {
        setMessage("验证成功！");
        // 继续注册流程
        const cleanedPhoneNumber = phoneNumber.replace(/\D/g, ''); // 去除特殊符号，只保留数字
        await checkPhoneNumber(cleanedPhoneNumber);
      } else {
        setError(response.data.msg || "验证码错误");
      }
    } catch (error) {
      setError("验证失败：" + (error.response?.data?.msg || "网络错误"));
    } finally {
      setIsVerifying(false);
    }
  };

  // 检查手机号码是否存在于数据库中
  const checkPhoneNumber = async (phoneNumber) => {
    try {
      const response = await axios.get(`/yonghu/findByPhone?shouji=${phoneNumber}`);
      
      if (response.data.code === 0) {
        // 如果手机号码存在，直接登录
        // setUsername(response.data.data.zhanghao);
        // setPassword(response.data.data.mima);

        console.log("response.data.zhanghao response.data.mima", response.data.data.zhanghao);
        
        await loginUser(response.data.data.zhanghao, response.data.data.mima);
      } else {
        // 如果手机号码不存在，创建新用户
        await registerUser(phoneNumber);
      }
    } catch (error) {
      console.error('Error checking phone number:', error);
      setError('查询用户信息失败');
    }
  };

  // 登录用户
  const loginUser = async (zhanghao, mima) => {
    const params = new URLSearchParams();
    params.append('username', zhanghao);
    params.append('password', mima);
    // try {
    //   const response = await axios.post('/yonghu/login', {
    //     shoujihao: phoneNumber,
    //     // 其他登录信息
    //   });
    //   if (response.data.success) {
    //     console.log('User logged in successfully');
    //     // 登录成功后的操作
    //   } else {
    //     setError('Failed to log in user');
    //   }
    // } catch (error) {
    //   console.error('Error logging in user:', error);
    //   setError('Error logging in user');
    // }
    console.log("params", params);
    
    try {
      const response = await axios.post('/yonghu/login', params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });
      
      if (response.data.code === 0) {
        const { userId, token } = response.data;
        const userData = { id: userId, zhanghao, role: 'yonghu' };

        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(userData));
        localStorage.setItem('userData', JSON.stringify(userData));
        
        login(userData, token);
        
        // 获取用户详情
        try {
          const userResponse = await axios.get(`/yonghu/info/${userId}`);
          if (userResponse.data.code === 0) {
            const fullUserData = {
              ...userData,
              ...userResponse.data.data
            };
            
            localStorage.setItem('user', JSON.stringify(fullUserData));
            localStorage.setItem('userData', JSON.stringify(fullUserData));
            login(fullUserData, token);
          }
        } catch (err) {
          console.error("获取用户详情失败:", err);
        }
        
        // 跳转到用户详情页
        navigate(`/users/${userId}`);
      } else {
        setError(response.data.msg || '登录失败');
      }
    } catch (err) {
      console.error('登录失败:', err);
      setError('登录请求失败');
    }
  };

  // 注册用户
  const registerUser = async (phoneNumber) => {
    // try {
    //   const response = await axios.post('/register', {
    //     phoneNumber,
    //     // 其他注册信息
    //   });
    //   if (response.data.success) {
    //     console.log('User registered successfully');
    //     // 注册成功后的操作
    //   } else {
    //     setError('Failed to register user');
    //   }
    // } catch (error) {
    //   console.error('Error registering user:', error);
    //   setError('Error registering user');
    // }
    const formData = {
      zhanghao: phoneNumber,
      mima: phoneNumber,
      xingming: phoneNumber,
      // 其他注册信息
    xingbie: '', // 性别
    shouji: phoneNumber, // 手机
    dizhi: '', // 地址
    tupian: '', // 图片
    addtime: '', // 添加时间
    };
    try {
      const response = await axios.post('/yonghu/register', {
        ...formData,
        id: '', // id 为空字符串
      });

      if (response.data.code === 0) {
        alert("注册成功！")
        // navigate('/login'); // 注册成功后跳转到登录页
        await loginUser(phoneNumber, phoneNumber);
      } else {
        setError(response.data.msg || '注册失败');
      }
    } catch (err) {
      console.error('Error registering user:', err);
      setError('注册请求失败，请稍后重试');
    }
  };

  return (
    <div className="home-page">
      <Header />
      <div className="auth-container">
        <div className="auth-header">
          <h1>手机验证登录</h1>
          <p>使用手机号快速登录或注册</p>
        </div>
        
        {message && !error && (
          <div className="auth-message">
            <FontAwesomeIcon icon={faCheckCircle} /> {message}
          </div>
        )}
        
        {error && (
          <div className="auth-error">
            <FontAwesomeIcon icon={faExclamationCircle} /> {error}
          </div>
        )}
        
        <form className="auth-form" onSubmit={handleVerifyOtp}>
          <div className="form-group">
            <label htmlFor="phoneNumber">
              <FontAwesomeIcon icon={faMobile} /> 手机号码
            </label>
            <div className="otp-container">
              <input
                id="phoneNumber"
                type="tel"
                className="otp-input"
                placeholder="请输入手机号"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                required
                disabled={isOtpSent}
              />
              <button 
                type="button" 
                className="otp-btn"
                onClick={handleSendOtp}
                disabled={isSending || isOtpSent && countdown > 0}
              >
                {isSending ? '发送中...' : 
                 countdown > 0 ? `${countdown}秒` : '发送验证码'}
              </button>
            </div>
          </div>
          
          {isOtpSent && (
            <div className="form-group">
              <label htmlFor="otp">
                <FontAwesomeIcon icon={faKey} /> 验证码
              </label>
              <input
                id="otp"
                type="text"
                placeholder="请输入验证码"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                required
              />
            </div>
          )}
          
          {isOtpSent && (
            <button 
              type="submit" 
              className="auth-btn"
              disabled={isVerifying}
            >
              {isVerifying ? '验证中...' : '验证并登录'}
              {!isVerifying && <FontAwesomeIcon icon={faPaperPlane} style={{ marginLeft: '8px' }} />}
            </button>
          )}
        </form>
        
        <div className="auth-links">
          <Link to="/login">使用账号密码登录</Link>
          <Link to="/register">注册新账号</Link>
        </div>
      </div>
    </div>
  );
};

export default UserMobileRegister;
